import type { GameMeta } from '@gmp/game-sdk';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const panicButtonMeta = {
  id: 'panic-button',
  name: 'Panic Button',
  tagline: 'Pick A or B. Your secret mission decides if it was right.',
  description:
    'Twenty seconds, two ridiculous options, one secret objective. Follow the crowd, defy it, shadow a rival or predict the split.',
  minPlayers: 2,
  maxPlayers: 20,
  estimatedMinutes: [5, 10],
  usesMedia: false,
  modes: [{ id: 'classic', name: 'Classic', description: 'Ten rapid rounds with secret objectives and surprise modifiers.' }],
  theme: { primary: '#ff2e4d', secondary: '#ffd60a', background: '#17171c', ink: '#fff7e0' },
  readiness: 'playable',
  genre: 'Secret-objective quickfire',
  controls: 'tap',
  category: 'party',
  instructions: [
    { icon: 'Siren', title: 'Read the panic', body: 'Everyone gets the same absurd situation and two options. You have 20 seconds (less if everyone answers sooner).' },
    { icon: 'EyeOff', title: 'Check your secret objective', body: 'Join the majority, be the rebel, copy or dodge a secret rival, or predict the split.' },
    { icon: 'Hand', title: 'Hit A or B', body: 'Lock in before time runs out. You can change your mind until everyone is in.' },
    { icon: 'Trophy', title: 'Score the reveal', body: '300 for a completed objective, 100 for a near miss, bonuses for perfect calls.' },
  ],
} satisfies GameMeta;
